import { FC, useId } from 'react';

import FancyRadio from '@rover/components/src/formFields/FancyRadioGroup/FancyRadio';
import RowList from '@rover/components/src/RowList';
import { Text } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';
import type { ServiceTypeOption, ServiceTypeSlug } from '@rover/types/src/ServiceType';

type Props = {
  serviceTypeOptions: ServiceTypeOption[];
  onChange: (_value: ServiceTypeSlug) => void;
  serviceType: ServiceTypeSlug;
};

type ServiceRowProps = ServiceTypeOption & Omit<Props, 'serviceTypeOptions'>;

const ServiceRow: FC<ServiceRowProps> = ({
  serviceType,
  title,
  subtitle,
  value,
  icon: Icon,
  labelBadge: LabelBadge,
  onChange,
}): JSX.Element => {
  const theme = useTheme();
  const inputId = useId();
  return (
    <RowList.Row
      key={value}
      label={
        <Text textColor="primary" marginBottom="0x" fontWeight="semibold" size={['100', '200']}>
          {title}
        </Text>
      }
      helperItem={LabelBadge ? <LabelBadge /> : undefined}
      sublabel={
        <Text textColor="secondary" marginBottom="0x" size={['100', '200']} fontWeight="regular">
          {subtitle}
        </Text>
      }
      labelHtmlFor={inputId}
      leftItem={Icon && <Icon fill={theme.colors.brand.active_brand} width="24px" height="24px" />}
      onClick={() => onChange(value)}
      rightItem={
        <FancyRadio
          actualId={inputId}
          id={`${value}`}
          labelIsProvidedViaHtmlFor
          value={`${serviceType === value}`}
          checked={serviceType === value}
          validationType="inline"
          name="ServiceType"
          onChange={() => onChange(value)}
          optionWidth="24"
          style={{ margin: '0', padding: '0' }}
        />
      }
    />
  );
};

export const ServiceList: FC<Props> = ({
  serviceType,
  serviceTypeOptions,
  onChange,
}): JSX.Element => {
  return (
    <RowList>
      {serviceTypeOptions.map((option) => (
        <ServiceRow key={option.value} {...option} serviceType={serviceType} onChange={onChange} />
      ))}
    </RowList>
  );
};
